var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"text-center mb-4"},[_c('font-awesome-icon',{staticClass:"text-primary mb-2",attrs:{"icon":['far', 'shield-check'],"size":"4x","variant":"primary"}}),_c('h1',[_vm._v("Verify Identity")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }